import type { ChatMessageListResponsePageAllOfThreeContentItemAllOfBasicInfo } from './chatMessageListResponsePageAllOfThreeContentItemAllOfBasicInfo';
import type { ChatMessageListResponsePageAllOfThreeContentItemAllOfSender } from './chatMessageListResponsePageAllOfThreeContentItemAllOfSender';
import type { ChatMessageListResponsePageAllOfThreeContentItemAllOfStatus } from './chatMessageListResponsePageAllOfThreeContentItemAllOfStatus';

export type ChatMessageListResponsePageAllOfThreeContentItemAllOf = {
  basicInfo?: ChatMessageListResponsePageAllOfThreeContentItemAllOfBasicInfo;
  /** 발신자 정보 */
  sender?: ChatMessageListResponsePageAllOfThreeContentItemAllOfSender;
  /** 메시지 상태 정보 */
  status?: ChatMessageListResponsePageAllOfThreeContentItemAllOfStatus;
};
